"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Personalization = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = require("./Button");
const PersonalizationModal_1 = require("./PersonalizationModal");
const fa_1 = require("react-icons/fa");
const react_2 = require("@headlessui/react");
const translations_1 = require("../i18n/translations");
const getConfigOptions = (item) => {
    if (!item)
        return [];
    const configOptions = item.configurationOptions || [];
    return [...configOptions];
};
const getPurchasePrice = (item) => {
    if (!item)
        return '';
    return item.purchasePrice.amount;
};
const getExtendedPrice = (item) => {
    if (!item)
        return '';
    return item.extendedPrice.amount;
};
function Personalization({ item, quantity, onRemove, onConfirm, onModalOpen, onModalClose, parentLineId, longDescription, supportsPersonalization, locale = 'en', }) {
    const { personalizeTitle, personalizeButtonText, personalizePopoverText, personalizeAnotherButtonText, personalizeAnotherPopoverText, personalizePopoverButtonLabel, personalizeAddAgainButtonText, personalizeAddAgainPopoverText, personalizeRemoveLink, personalizeEditLink, personalizeShippingLabel, personalizeStyleLabel, personalizeTextLabel, personalizeLine1Label, personalizeLine2Label, personalizeDifferentText, personalizeUnitPriceLabel, personalizeScriptLabel, personalizeBlockLabel, } = translations_1.personalizeContent[locale];
    const [purchasePrice, setPurchasePrice] = (0, react_1.useState)('');
    const [extendedPrice, setExtendedPrice] = (0, react_1.useState)('');
    const [configOptions, setConfigOptions] = (0, react_1.useState)([]);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [isDuplicate, setIsDuplicate] = (0, react_1.useState)(false);
    const [isPersonizable, setIsPersonalizable] = (0, react_1.useState)(supportsPersonalization);
    (0, react_1.useEffect)(() => {
        setConfigOptions(getConfigOptions(item));
        setPurchasePrice(getPurchasePrice(item));
        setExtendedPrice(getExtendedPrice(item));
    }, [item]);
    (0, react_1.useEffect)(() => {
        setIsPersonalizable(supportsPersonalization);
    }, [supportsPersonalization]);
    let [font, setFont] = (0, react_1.useState)('');
    let [text, setText] = (0, react_1.useState)('');
    const capitalize = (s) => s.toUpperCase()[0] + s.substring(1);
    if (configOptions.length > 0) {
        [font, text] = configOptions.map((configOption) => {
            return configOption.configValue;
        });
        font = capitalize(font);
    }
    const [line1, line2] = text.split('\n');
    const confirmCallback = (parentLineId, textValue, fontValue) => __awaiter(this, void 0, void 0, function* () {
        setIsModalOpen(false);
        // TODO: More than 3 args, Convert to object
        onConfirm({
            lineId: parentLineId,
            content: {
                text: textValue,
                fontStyle: fontValue,
            },
            duplicate: isDuplicate,
        }).then(() => {
            if (isDuplicate) {
                setIsDuplicate(false);
                return;
            }
            setFont(capitalize(fontValue));
            setText(textValue);
        });
    });
    const fontStyle = font === 'Script' ? 'font-script' : 'font-helvetica uppercase';
    const closeCallback = () => {
        setIsDuplicate(false);
        setIsModalOpen(false);
        onModalClose();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        configOptions.length ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { "data-testid": `personalization-section-${parentLineId}`, className: "personalization-summary pl-4 py-2 pr-2 border-left border-yellow border-l-4 grid grid-cols-12 gap-x-2 gap-y-1 bg-gray-f7" },
                react_1.default.createElement("div", { className: "col-span-12 md:col-span-9 md:row-start-1 pr-4" },
                    react_1.default.createElement("h4", { className: "font-bold mb-2 md:text-base" }, `${personalizeTitle} (${quantity})`),
                    react_1.default.createElement("p", { className: "mb-1" },
                        react_1.default.createElement("span", { className: "inline-block font-bold mr-1" },
                            personalizeShippingLabel,
                            ":",
                            ' '),
                        longDescription),
                    react_1.default.createElement("p", { className: "mb-1" },
                        react_1.default.createElement("span", { className: "inline-block font-bold mr-1" },
                            personalizeStyleLabel,
                            ":",
                            ' '),
                        font === 'Script'
                            ? personalizeScriptLabel
                            : personalizeBlockLabel),
                    react_1.default.createElement("p", { className: "mb-1" },
                        react_1.default.createElement("span", { className: "inline-block font-bold mr-1 align-text-top" },
                            line1 ? personalizeLine1Label : personalizeTextLabel,
                            ': '),
                        react_1.default.createElement("span", { className: `inline-block font-bold align-text-top ${fontStyle}` }, line1)),
                    line2 && (react_1.default.createElement("p", { className: "mb-1" },
                        react_1.default.createElement("span", { className: "inline-block font-bold mr-1 align-text-top" },
                            personalizeLine2Label,
                            ":",
                            ' '),
                        react_1.default.createElement("span", { className: `inline-block font-bold align-text-top ${fontStyle}` }, line2)))),
                react_1.default.createElement("div", { className: "col-span-12 md:col-span-3 md:text-right md:row-start-1 md:col-start-10 mb-1" },
                    react_1.default.createElement("p", { className: "font-bold text-base md:text-lg" },
                        "$",
                        extendedPrice),
                    react_1.default.createElement("p", { className: "text-sm" },
                        personalizeUnitPriceLabel,
                        " $",
                        purchasePrice)),
                react_1.default.createElement("div", { className: "col-span-12" },
                    react_1.default.createElement("div", { className: "-ml-3" },
                        react_1.default.createElement("button", { "data-testid": `edit-personalization-${parentLineId}`, className: "px-3 inline-block link", onClick: () => setIsModalOpen(true) }, personalizeEditLink),
                        "|",
                        react_1.default.createElement("button", { "data-testid": `remove-personalization-${parentLineId}`, className: "px-3 inline-block text-red hover:text-red-hover focus:text-red-hover focus:underline hover:underline", onClick: () => onRemove(parentLineId) }, personalizeRemoveLink)))),
            react_1.default.createElement("div", { className: "personalization-another mt-4" },
                react_1.default.createElement("p", { className: "mb-2 font-bold" }, personalizeDifferentText),
                react_1.default.createElement("div", { className: "flex flex-wrap -mx-4" },
                    react_1.default.createElement("div", { className: "px-4 mb-2 flex align-middle" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Button_1.Button, { variant: "blue", "data-testid": `personalize-again-${parentLineId}`, className: '!rounded-3xl', onClick: () => {
                                    setIsDuplicate(true);
                                    setIsModalOpen(true);
                                    onModalOpen();
                                } }, personalizeAnotherButtonText)),
                        react_1.default.createElement("div", { className: "relative ml-2" },
                            react_1.default.createElement(InfoPopover, { className: "relative top-1/2 -translate-y-1/2", message: personalizeAnotherPopoverText, buttonText: react_1.default.createElement(fa_1.FaQuestionCircle, { className: "text-blue hover:text-blue-hover text-2xl" }), buttonClass: "block", buttonAriaLabel: personalizePopoverButtonLabel }))),
                    react_1.default.createElement("div", { className: "px-4 mb-2 flex align-middle" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Button_1.Button, { variant: "blue", "data-testid": `add-another-${parentLineId}`, className: '!rounded-full', onClick: () => {
                                    onConfirm({
                                        lineId: parentLineId,
                                        content: null,
                                        duplicate: true,
                                    });
                                } }, personalizeAddAgainButtonText)),
                        react_1.default.createElement("div", { className: "relative ml-2" },
                            react_1.default.createElement(InfoPopover, { className: "relative top-1/2 -translate-y-1/2", message: personalizeAddAgainPopoverText, buttonText: react_1.default.createElement(fa_1.FaQuestionCircle, { className: "text-blue hover:text-blue-hover text-2xl" }), buttonClass: "block", buttonAriaLabel: personalizePopoverButtonLabel }))))))) : (isPersonizable && (react_1.default.createElement("div", { className: "personalize-button mb-2 flex align-middle" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Button_1.Button
                // className={classNames('!rounded-full')}
                , { "data-testid": `personalize-${parentLineId}`, variant: "blue", onClick: () => {
                        setIsModalOpen(true);
                        onModalOpen();
                    } }, personalizeButtonText)),
            react_1.default.createElement("div", { className: "relative ml-2" },
                react_1.default.createElement(InfoPopover, { className: "relative top-1/2 -translate-y-1/2", message: personalizePopoverText, buttonText: react_1.default.createElement(fa_1.FaQuestionCircle, { className: "text-blue hover:text-blue-hover text-2xl" }), buttonClass: "block", buttonAriaLabel: personalizePopoverButtonLabel }))))),
        react_1.default.createElement(PersonalizationModal_1.PersonalizationModal, { font: font, text: text, isOpen: isModalOpen, onConfirm: confirmCallback, parentLineId: parentLineId, onClose: closeCallback, locale: locale })));
}
exports.Personalization = Personalization;
function InfoPopover({ as = 'div', className, message, buttonText, buttonClass, buttonAriaLabel, props, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Popover, Object.assign({ as: as, className: (0, classnames_1.default)(className, '') }, props), ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Popover.Button, { "aria-label": buttonAriaLabel, className: (0, classnames_1.default)(buttonClass, '') }, buttonText),
            react_1.default.createElement(react_2.Transition, { show: open, enter: "transition duration-200 absolute ease-out w-full", enterFrom: "transform opacity-0", enterTo: "transform opacity-100", leave: "transition duration-200 ease-out absolute w-full", leaveFrom: "transform opacity-100", leaveTo: "transform opacity-0", className: "absolute top-0 z-30" },
                react_1.default.createElement(react_2.Popover.Panel, { className: "text-center bg-white shadow-md-all rounded-lg text-sm absolute -top-1.5 -translate-y-full p-4 py-2 w-48 sm:w-64 text-gray left-1/2 -translate-x-1/2 border border-[#f4f4f4]", static: true },
                    react_1.default.createElement("span", { style: {
                            borderLeft: '8px solid transparent',
                            borderRight: '8px solid transparent',
                            borderTop: '8px solid #f2f2f2',
                            bottom: '-8px',
                            position: 'absolute',
                        }, className: "left-1/2 -translate-x-1/2", "aria-hidden": "true" }),
                    react_1.default.createElement("span", { style: {
                            borderLeft: '8px solid transparent',
                            borderRight: '8px solid transparent',
                            borderTop: '8px solid white',
                            bottom: '-6px',
                            position: 'absolute',
                        }, className: "left-1/2 -translate-x-1/2", "aria-hidden": "true" }),
                    message)))))));
}
